import { PosixDateTransformer, } from "@for-it/domain-lib";
import { EntitySchema } from "typeorm";
import { StatusType } from "./certification.js";
export const CertificationUserEntity = new EntitySchema({
    name: "certification_users",
    columns: {
        id: {
            type: "uuid",
            primary: true,
        },
        certificationId: {
            type: "uuid",
            nullable: false,
        },
        userId: {
            type: "uuid",
            nullable: false,
        },
        receivedAt: {
            type: "date",
            nullable: true,
            transformer: PosixDateTransformer,
        },
        status: {
            type: "varchar",
            enum: StatusType,
            default: StatusType.PENDING,
        },
        approvedAt: {
            type: "date",
            nullable: true,
            transformer: PosixDateTransformer,
        },
    },
    relations: {
        cert: {
            type: "many-to-one",
            target: "certifications",
            joinColumn: {
                name: "certificationId",
            },
            onDelete: "CASCADE",
        },
        user: {
            type: "many-to-one",
            target: "users",
            joinColumn: {
                name: "userId",
            },
            onDelete: "CASCADE",
        },
    },
});
